import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";

function useStore() {
  const { element, setBackendFormErrors } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("options", element)
      .then((response: any) => {
        setBackendFormErrors({});
        onSuccess(response.data);
      })
      .catch((error: any) => {        
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
